/* components */
import { Grid, InputBase, Box } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
/* styles */
import useStyles from './useStyles'
/* translations */

function SearchField ({ cerrarFn }) {
  const classes = useStyles()
  return (
    <>
      <Grid container className={classes.search}>
        <InputBase
          startAdornment={
            <>
              <SearchIcon className={classes.icon} />
            </>
          }
          endAdornment={
            <Box onClick={cerrarFn} className={classes.cancelContainer}>
              <CloseOutlinedIcon className={classes.icon} />
            </Box>
          }
          className={classes.inputField}
        />
      </Grid>
    </>
  )
}

export default SearchField
